import React from "react";

function Icon({ name, className = "h-5 w-5" }) {
  if (name === "whatsapp") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        className={className}
      >
        <path d="M12.031 2c-5.517 0-9.993 4.476-9.993 9.993 0 1.763.463 3.42 1.269 4.871l-1.307 4.807 4.931-1.292c1.408.766 3.012 1.205 4.717 1.205 5.517 0 9.993-4.476 9.993-9.993s-4.476-9.993-9.993-9.993zm5.75 14.12c-.24.675-1.188 1.229-1.918 1.305-.5.051-1.148.083-1.846-.147-3.006-.992-4.947-4.043-5.097-4.244-.149-.201-1.209-1.612-1.209-3.078 0-1.466.764-2.189 1.034-2.489.27-.3.59-.375.787-.375.197 0 .393.001.564.01.184.01.432-.07.675.51.243.585.832 2.031.905 2.181.073.15.122.325.022.525-.1.2-.15.325-.3.5-.15.175-.315.39-.45.525-.151.15-.309.313-.133.613.176.3.784 1.296 1.685 2.097.771.686 1.419.897 1.719 1.047.3.15.474.125.649-.075.176-.2.749-.874.949-1.174.2-.3.4-.25.674-.15.275.1.1.75 1.748.874 1.648.125.275.25.375.25.1.24.425.21.675z" />
      </svg>
    );
  }
  if (name === "phone") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      >
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
      </svg>
    );
  }
  if (name === "mail") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      >
        <rect x="2" y="4" width="20" height="16" rx="2" />
        <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
      </svg>
    );
  }
  return null;
}

export default function Contact() {
  return (
    <section id="contact" className="bg-slate-50 py-24">
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Column: Text Content */}
          <div>
            <span className="text-red-600 font-bold tracking-widest uppercase text-sm">
              Contact Me
            </span>
            <h2 className="mt-2 text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">
              Let’s Secure Your Future Together
            </h2>
            <p className="mt-6 text-lg text-slate-600 leading-relaxed">
              Have questions about health insurance or wealth planning? Reach
              out today for a
              <span className="text-slate-900 font-semibold">
                {" "}
                free, no-obligation consultation
              </span>
              . I am here to guide you through every step of your protection
              journey.
            </p>

            <div className="mt-8 flex items-center gap-3">
              <span className="relative flex h-3 w-3">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500"></span>
              </span>
              <p className="text-sm font-bold text-slate-700 uppercase tracking-wide">
                Available for Consultations
              </p>
            </div>
          </div>

          {/* Right Column: Contact Cards */}
          <div className="space-y-4">
            <div className="rounded-3xl bg-white p-2 shadow-xl shadow-slate-200/60 ring-1 ring-slate-100">
              {/* Phone */}
              <a
                href="tel:+94117710452"
                className="flex items-center justify-between p-4 sm:p-6 rounded-2xl hover:bg-red-50 transition-all group"
              >
                <div className="flex items-center gap-5">
                  <div className="h-12 w-12 rounded-xl bg-red-600 text-white flex items-center justify-center shadow-lg shadow-red-200 group-hover:scale-110 transition-transform">
                    <Icon name="phone" className="h-6 w-6" />
                  </div>
                  <div>
                    <p className="text-xs uppercase tracking-widest font-bold text-slate-400">
                      Direct Line
                    </p>
                    <p className="text-lg font-bold text-slate-900 mt-0.5">
                      +94 11 771 0452
                    </p>
                  </div>
                </div>
                <div className="h-10 w-10 rounded-full border border-slate-100 flex items-center justify-center group-hover:bg-red-600 group-hover:text-white transition-all">
                  <span className="text-xl">→</span>
                </div>
              </a>

              <div className="h-px bg-slate-50 mx-6"></div>

              {/* WhatsApp */}
              <a
                href="https://wa.me/94766268043"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-between p-4 sm:p-6 rounded-2xl hover:bg-emerald-50 transition-all group"
              >
                <div className="flex items-center gap-5">
                  <div className="h-12 w-12 rounded-xl bg-emerald-500 text-white flex items-center justify-center shadow-lg shadow-emerald-200 group-hover:scale-110 transition-transform">
                    <Icon name="whatsapp" className="h-6 w-6" />
                  </div>
                  <div>
                    <p className="text-xs uppercase tracking-widest font-bold text-slate-400">
                      WhatsApp
                    </p>
                    <p className="text-lg font-bold text-slate-900 mt-0.5">
                      +94 76 626 8043
                    </p>
                  </div>
                </div>
                <div className="h-10 w-10 rounded-full border border-slate-100 flex items-center justify-center group-hover:bg-emerald-500 group-hover:text-white transition-all">
                  <span className="text-xl">→</span>
                </div>
              </a>

              <div className="h-px bg-slate-50 mx-6"></div>

              {/* Email */}
              <a
                href="mailto:ruwan.indika@aialanka.com.lk"
                className="flex items-center justify-between p-4 sm:p-6 rounded-2xl hover:bg-slate-900 group transition-all"
              >
                <div className="flex items-center gap-5">
                  <div className="h-12 w-12 rounded-xl bg-slate-100 text-slate-600 flex items-center justify-center group-hover:bg-white group-hover:text-slate-900 transition-colors">
                    <Icon name="mail" className="h-6 w-6" />
                  </div>
                  <div>
                    <p className="text-xs uppercase tracking-widest font-bold text-slate-400 group-hover:text-slate-400">
                      Official Email
                    </p>
                    <p className="text-lg font-bold text-slate-900 mt-0.5 group-hover:text-white truncate max-w-[180px] sm:max-w-none">
                      ruwan.indika@aialanka.com.lk
                    </p>
                  </div>
                </div>
                <div className="h-10 w-10 rounded-full border border-slate-100 flex items-center justify-center group-hover:border-slate-700 group-hover:text-white transition-all">
                  <span className="text-xl">→</span>
                </div>
              </a>
            </div>

            {/* Bottom Branding Badge */}
            <div className="px-6 py-4 rounded-2xl border-l-4 border-red-600 bg-white shadow-sm flex items-center justify-between">
              <p className="text-xs font-bold text-slate-500 uppercase">
                District Executive Wealth Planner
              </p>
              <span className="text-[10px] font-black text-red-600 tracking-tighter">
                AIA LANKA
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
